import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { SelectFieldFloatingLabel as Select, InputFieldFloatingLabel as InputField } from '../../../../../common/custom-form/select-filter.component';
import DATEPICKER_OR from "../../../../../common/custom-form/custom-date-picker.component";
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';

class MrcRechargingInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: false
        }
    }

    handleToggle = () =>{
        this.setState(prev => ({isCollapsed: !prev.isCollapsed}))
    }

    isMrcRecharge = () =>{
        const { rechargeInventoryDetailsForm } = this.props;
        return rechargeInventoryDetailsForm.mrcInformation.mrcRecharge === "true" ||
               rechargeInventoryDetailsForm.mrcInformation.mrcRecharge === true ? "required" : null
    }
    isRechargeViaDummyInvoice = () =>{
        const { rechargeInventoryDetailsForm } = this.props;
        return rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice === "true" ||
               rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice === true ? "required" : null
    }

    render() {
        const { isCollapsed } = this.state;
        const { translator, rechargeInventoryDetails, rechargeInventoryDetailsForm } = this.props;

        const isDisabledMrcAmountField = rechargeInventoryDetailsForm.mrcInformation.mrcRecharge === "true" || rechargeInventoryDetailsForm.mrcInformation.mrcRecharge === true ? false : true;
        const isDisabledDLIAmountField = rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice === "true" || rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice === true ? false : true;

        return (
            <div className="control-container">
                
            <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={() => {this.handleToggle()}} label={translator("Mrc_recharging_information", false)} >
                <div className={`add-sim-container detail-page-container details-4-col-container`}>
                    
                <div style={{ gridColumn: 'span 1' }}> 
                    <Select
                        className="form-select no-select__option required"
                        label={translator('mrc_recharge')}
                        options={rechargeInventoryDetails.mrcRechargeDropdown.data}
                        value={rechargeInventoryDetailsForm.mrcInformation.mrcRecharge}
                        placeholder={translator('select_placeholder', false)}
                        fieldProp='rechargeInventoryDetailsForm.mrcInformation.mrcRecharge'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                        onChangeAction={(e, v) => this.props.onChangeMrcSelect(e, v)}
                    />
                    </div>
                    <div style={{ gridColumn: 'span 1' }}>
                    <InputField
                        className={`form-control ${this.isMrcRecharge()}`}
                        type="text"
                        label={translator('mrc_recharge_amount')}
                        value={rechargeInventoryDetailsForm.mrcInformation.mrcRecharge === "false" ? '0.00000' : rechargeInventoryDetailsForm.mrcInformation.mrcRechargeAmount}
                        fieldProp='rechargeInventoryDetailsForm.mrcInformation.mrcRechargeAmount'
                        placeholder={"0.00000"}
                        disabled={isDisabledMrcAmountField}
                        hasDecimalLimit={true}
                        decimalFormat={[18,5]}
                    />
                    </div>
                    
                    <div className="horizontal-separator custom-separator"  style={{ gridColumn: 'span 4' }}/>

                    <Select
                        className="form-select no-select__option required"
                        label={translator('recharge_via_dummy_invoice')}
                        options={rechargeInventoryDetails.rechargeViaDummyInvoiceDropdown.data}
                        value={rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice}
                        placeholder={translator('select_placeholder', false)}
                        fieldProp='rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                        onChangeAction={(e, v) => this.props.onChangeMrcSelect(e, v)}
                    />

                    <InputField
                        className={`form-control ${this.isRechargeViaDummyInvoice()}`}
                        type="text"
                        label={translator('dummy_line_item_amount')}
                        value={rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice === "false" ? "0.00000" : rechargeInventoryDetailsForm.mrcInformation.dummyLineItemAmount}
                        fieldProp='rechargeInventoryDetailsForm.mrcInformation.dummyLineItemAmount'
                        placeholder={"0.00000"}
                        disabled={isDisabledDLIAmountField}
                        hasDecimalLimit={true}
                        decimalFormat={[18,5]}
                    />

                    <DATEPICKER_OR 
                        dateOnly={true} 
                        label={`${translator('dummy_invoice_date')}`} 
                        placeholder={`${translator('select_placeholder', false)}`} 
                        startDate={rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDate} 
                        selectedDate={(date) => this.props.FormChange("rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDate", date)}
                        isDisable={rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice === "true" ? false : true}
                        requiredField={this.isRechargeViaDummyInvoice()? true : false}
                    />

                    <DATEPICKER_OR 
                        dateOnly={true} 
                        label={`${translator('dummy_invoice_due_date')}`} 
                        placeholder={`${translator('select_placeholder', false)}`} 
                        startDate={rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDueDate} 
                        selectedDate={(date) => this.props.FormChange("rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDueDate", date)}
                        isDisable={rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice === "true" ? false : true}
                        requiredField={this.isRechargeViaDummyInvoice()? true : false}
                    />
                </div>
            </CustomDropdown>
        </div>
        );
    }
}


export default connect(
    state => {
        const { rechargeInventoryDetails, translation } = state;
        const { rechargeInventoryDetailsForm } = state.form;
        return {
            ...translation,
            rechargeInventoryDetails,
            rechargeInventoryDetailsForm
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, RechargeInventoryDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(MrcRechargingInformation);